<div class="modal-header bg-dark">
    <h4 class="modal-title">Pianificazione <strong>Ispezione</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<form #contractFounderCreateForm="ngForm" role="form" class="form-horizontal form-validation">
    <div class="modal-body">
        <div class="form-group">
            <label for="start" class="col-sm-3 control-label">Data e Ora *</label>
            <div class="col-sm-9 prepend-icon">
                <input type="datetime-local"
                       id="start"
                       name="start"
                       class="form-control"
                       data-lang="it"
                       data-autoclose="true"
                       data-orientation="bottom left"
                       autocomplete="off"
                       required
                       [ngClass]="{
                        'form-success': date !== null
                     }"
                       [(ngModel)]="date">
                <i class="icon-calendar"></i>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit"
                [disabled]="!contractFounderCreateForm.form.valid"
                class="btn btn-embossed btn-primary"
                (click)="activeModal.close(date)">
            <i class="icon-plus"></i> Salva Pianificazione
        </button>
        <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.dismiss()">Chiudi</button>
    </div>
</form>
